import React, { useEffect, useState } from "react";

const icons = ["💊", "🩺", "❤️", "🧴"];

export default function LoadingAnimation({ small }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % icons.length);
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* 🔥 Inject CSS here */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 0.7; }
            50% { transform: scale(1.2); opacity: 1; }
            100% { transform: scale(1); opacity: 0.7; }
          }
        `}
      </style>

      <div style={small ? styles.small : styles.container}>
        <span style={small ? styles.smallIcon : styles.icon}>
          {icons[index]}
        </span>
      </div>
    </>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #e0f2fe, #f0fdf4)", // 🔥 added
  },
  icon: {
    fontSize: "60px",
    animation: "pulse 1s infinite",
  },

  small: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  smallIcon: {
    fontSize: "20px",
  },
};
